import { LoadingIndicator } from '../common/components/loading-indicator';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { useAutoNavigateToEvent } from '../fr-navigation/hooks/use-auto-navigate-to-event';
import { useUnitAssignment } from '../unit-assignment/unit-assignment-context';
import { FrAssignedEventPageContent as FrAssignedEventPageContent } from './components/fr-assigned-event-page-content';
import { FrEventProviders } from './components/fr-event-providers';
import { ErrorBoundary } from '../monitoring/error-boundary';

export function FrAssignedEventPage() {
    const unitAssignment = useUnitAssignment();
    useAutoNavigateToEvent();
    const { query: eventQuery } = useIntegratedForm();

    const eventId = unitAssignment?.assignedEvent?.eventId;

    if (eventQuery.isLoading) {
        return <LoadingIndicator />;
    }

    return (
        <ErrorBoundary name="FR_ASSIGNED_EVENT">
            <FrEventProviders eventId={eventId}>
                <FrAssignedEventPageContent />
            </FrEventProviders>
        </ErrorBoundary>
    );
}
